import moment from 'moment';
import groupBy from 'lodash/groupBy';

/**
 * Gets the first element of array
 * @export
 * @param {array} array -The array to query
 * @returns {any} The element, if array not empty
 */
export function first(array) {
	return array && array.length ? array[0] : null;
}

/**
 * Creates an array of numbers progressing from start up to, but not including, end.
 * @export
 * @param {number} start -The start number
 * @param {number} end -The end number
 * @returns {array} The array containing the range of numbers
 */
export function range(start, end) {
	return Array.from(
		{ length: end - start },
		(element, position) => position + start
	);
}

/**
 * Gets the total count
 * @export
 * @param {array} products -The array containing the data needed
 * @param {string} prop -The object property
 * @returns {number} -The total count
 */
export function getTotalCount(products, prop) {
	return products
		? products.reduce((sum, item) => (item[prop] ? sum + item[prop] : sum), 0)
		: 0;
}

/**
 * Gets the days left between the given date and today
 * @export
 * @param {moment} endDate -The date for which calculate days left
 * @returns {string} - The days left or Expires Today string
 */
export function getDaysLeft(endDate) {
	const today = moment();

	if (today.isSame(endDate, 'day')) {
		return 'Expires today';
	}

	return today.isBefore(endDate)
		? `${endDate.diff(today, 'days')} days left`
		: '0 days left';
}

/**
 * Finds an element in an array of objects
 * @export
 * @param {array} items -The array containing the data needed
 * @param {string} value -The element we are looking for
 * @param {string} prop -The object property
 * @returns {object} - The object containing the element
 */
export function findInArray(items, value, prop) {
	return items.find(product => product[prop] === value);
}

/**
 * Groups an array after a property
 * @export
 * @param {array} items -The array containing the data needed
 * @param {string} prop -The property after which the grouping is made
 * @returns {array} - The groups
 */
export function arrayGrouping(items, prop) {
	return groupBy(items, prop);
}

/**
 * Sorts an array of objects, after a given property
 * @export
 * @param {array} items -The array to be sorted
 * @param {string} prop -The property after which we sort
 * @returns {array} - The sorted array
 */
export function sortArray(items, prop) {
	return items.sort((first, second) => {
		const firstItem =
			typeof first[prop] === 'string' ? first[prop].toUpperCase() : first[prop];
		const secondItem =
			typeof second[prop] === 'string'
				? second[prop].toUpperCase()
				: second[prop];

		if (firstItem > secondItem) {
			return 1;
		}

		if (firstItem < secondItem) {
			return -1; // eslint-disable-line
		}

		return 0;
	});
}

/**
 * Get index on an item in array
 * @export
 * @param {array} items -The items
 * @param {string} prop -The property after which we get the index
 * @param {number} value -Value we are looking for to get the index of
 * @returns {number} - The index
 */
export function getIndex(items, prop, value) {
	return items.findIndex(item => item[prop] === value);
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js